import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Typography,
  Card,
  CardActions,
  CardBody,
  CardTitle,
} from '@one-thd/sui-atomic-components';
import './preferenceCard.scss';
import { NO, YES } from '../../constants/constants';
import TableDataShape from '../../shapes/TableData';
import HeaderColumnShape from '../../shapes/HeaderColumn';
import { PHONE_TITLE, PHONE_TYPE } from '../tableData';

const namedTableRow = (name, tableData, setTableData, setSelectedItems, handleSelectedItem, telemarketingCard) => {
  return (title) => {
    const row = tableData[title];

    const onChange = (event) => {
      let { id, checked } = event.target;
      let value = (checked) ? YES : NO;
      let item = id.split('-')[1];
      let table = tableData;

      handleSelectedItem(table[item], checked);

      setSelectedItems((items) => {
        return items.includes(item)
          ? items.filter((i) => i !== item)
          : [...items, item];
      });

      table[item].value = value;

      setTableData(table);
    };

    const checked = row?.value === YES;
    const isTelephone = tableData[title].type === PHONE_TYPE;

    function displayOptOutCard(type) {
      return (
        <Card>
          <CardTitle
            headerVariant="h5"
            header={(
              <Typography
                variant="h5"
                weight="base"
                height="snug"
                lineClamp="3"
              >
                {type}
              </Typography>
            )}
          />
          <CardBody>
            <Typography>
              You have previously opted out of {type.toLowerCase()}
            </Typography>
          </CardBody>
        </Card>
      );
    }

    return (
      <>
        {isTelephone && telemarketingCard ? (displayOptOutCard(PHONE_TITLE)
        ) : (
          <Card key={`${name}-${title}`}>
            <CardTitle
              header={(
                <Typography
                  variant="h5"
                  weight="base"
                  height="snug"
                  lineClamp="3"
                >
                  {title}
                </Typography>
              )}
              key={title}
            />
            <CardBody>
              <Typography>
                {row.subText}
              </Typography>
            </CardBody>
            <CardActions>
              <Checkbox
                formName={`${name}-${title}`}
                name={`${name}-${title}`}
                id={`${name}-${title}`}
                onChange={onChange}
                checked={checked}
                value={row.value}
              />
            </CardActions>
          </Card>
        )}
      </>
    );
  };
};

function PreferenceCard({
  isMobile, name, headerColumn, tableData, setTableData, setSelectedItems, handleSelectedItem, telemarketingCard
}) {
  const tableRow = namedTableRow(name, tableData, setTableData, setSelectedItems, handleSelectedItem,
    telemarketingCard);

  return (
    <div data-testid={`${headerColumn.name}-preference-table`} className="preference-table-container">
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2
        md:sui-grid-cols-3 xl:sui-grid-cols-4 sui-gap-4 sui-py-8"
      >
        {Object.keys(tableData).map(tableRow)}
      </div>
    </div>
  );
}

PreferenceCard.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  headerColumn: HeaderColumnShape.isRequired,
  tableData: TableDataShape.isRequired,
  name: PropTypes.string.isRequired,
  setTableData: PropTypes.func.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  handleSelectedItem: PropTypes.func,
  telemarketingCard: PropTypes.bool
};

PreferenceCard.defaultProps = {
  handleSelectedItem: () => {
  },
  telemarketingCard: false
};

export default PreferenceCard;
